import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: "authentication",
  initialState: {
    loggedIn: false,
    user: {}
  },
  reducers: {
    set: (state, action) => {
      state.user = action.payload;
      state.loggedIn = true;
    },
    clear: (state) => {
      state.user = {}
      state.loggedIn = false
    }
  }
});

export const { set: setUser, clear: clearUser } = userSlice.actions;
export default userSlice.reducer;